import { AUTO_LOGIN, ACCESS_TOKEN, REFRESH_TOKEN } from "@/types";

export default function useSetTokens(
  accessToken: string,
  refreshToken: string
): void {
  const isAutoLogin = window.localStorage.getItem(AUTO_LOGIN) === "true";
  if (isAutoLogin) {
    window.localStorage.setItem(ACCESS_TOKEN, accessToken);
    window.localStorage.setItem(REFRESH_TOKEN, refreshToken);
  } else {
    window.sessionStorage.setItem(ACCESS_TOKEN, accessToken);
    window.sessionStorage.setItem(REFRESH_TOKEN, refreshToken);
  }
}
